const VisibilityTypes = {
  GET_SUPPLIER_TYPES: 'GET_SUPPLIER_TYPES',
  GET_SUPPLIER_TYPES_SUCCESS: 'GET_SUPPLIER_TYPES_SUCCESS',
  GET_SUPPLIER_TYPES_ERROR: 'GET_SUPPLIER_TYPES_ERROR',

  UPDATE_VISIBILITY_SEARCH_LIST: 'UPDATE_VISIBILITY_SEARCH_LIST',
  UPDATE_VISIBILITY_SEARCH_LIST_SUCCESS: 'UPDATE_VISIBILITY_SEARCH_LIST_SUCCESS',

  GET_VISIBILITY_SEARCH_LIST: 'GET_VISIBILITY_SEARCH_LIST',
  GET_VISIBILITY_SEARCH_LIST_SUCCESS: 'GET_VISIBILITY_SEARCH_LIST_SUCCESS',
  GET_VISIBILITY_SEARCH_LIST_FAIL: 'GET_VISIBILITY_SEARCH_LIST_FAIL',
  GET_VISIBILITY_SEARCH_LIST_CLEAR: 'GET_VISIBILITY_SEARCH_LIST_CLEAR',
  GET_VISIBILITY_SET_SEARCH_LIST_DATA: 'GET_VISIBILITY_SET_SEARCH_LIST_DATA',

  GET_TRACKING_STATUS_DETAILS: 'GET_TRACKING_STATUS_DETAILS',
  GET_TRACKING_STATUS_DETAILS_SUCCESS: 'GET_TRACKING_STATUS_DETAILS_SUCCESS',
  GET_TRACKING_STATUS_DETAILS_FAIL: 'GET_TRACKING_STATUS_DETAILS_FAIL',

  GET_VISIBILITY_PRODUCT_INFO: 'GET_VISIBILITY_PRODUCT_INFO',
  GET_VISIBILITY_PRODUCT_INFO_SUCCESS: 'GET_VISIBILITY_PRODUCT_INFO_SUCCESS',
  GET_VISIBILITY_PRODUCT_INFO_FAIL: 'GET_VISIBILITY_PRODUCT_INFO_FAIL',

  GET_SHIPMENT_NOTES_AND_DETAILS: 'GET_SHIPMENT_NOTES_AND_DETAILS',
  GET_SHIPMENT_NOTES_AND_DETAILS_SUCCESS: 'GET_SHIPMENT_NOTES_AND_DETAILS_SUCCESS',
  GET_SHIPMENT_NOTES_AND_DETAILS_FAIL: 'GET_SHIPMENT_NOTES_AND_DETAILS_FAIL',

  GET_SHIPPER_AND_CONSIGNEE_DETAILS: 'GET_SHIPPER_AND_CONSIGNEE_DETAILS',
  GET_SHIPPER_AND_CONSIGNEE_DETAILS_SUCCESS: 'GET_SHIPPER_AND_CONSIGNEE_DETAILS_SUCCESS',
  GET_SHIPPER_AND_CONSIGNEE_DETAILS_FAIL: 'GET_SHIPPER_AND_CONSIGNEE_DETAILS_FAIL',

  GET_TRANSPORTATION_PROVIDER: 'GET_TRANSPORTATION_PROVIDER',
  GET_TRANSPORTATION_PROVIDER_SUCCESS: 'GET_TRANSPORTATION_PROVIDER_SUCCESS',
  GET_TRANSPORTATION_PROVIDER_FAIL: 'GET_TRANSPORTATION_PROVIDER_FAIL',

  UPDATE_SHIPMENT_TRACKING_DETAILS: 'UPDATE_SHIPMENT_TRACKING_DETAILS',
  UPDATE_SHIPMENT_TRACKING_DETAILS_SUCCESS: 'UPDATE_SHIPMENT_TRACKING_DETAILS_SUCCESS',
  UPDATE_SHIPMENT_TRACKING_DETAILS_FAIL: 'UPDATE_SHIPMENT_TRACKING_DETAILS_FAIL',
  UPDATE_SHIPMENT_TRACKING_DETAILS_CLEAR: 'UPDATE_SHIPMENT_TRACKING_DETAILS_CLEAR',

  GET_VISIBILITY_EXCEPTION: 'GET_VISIBILITY_EXCEPTION',
  GET_VISIBILITY_EXCEPTION_SUCCESS: 'GET_VISIBILITY_EXCEPTION_SUCCESS',
  GET_VISIBILITY_EXCEPTION_FAIL: 'GET_VISIBILITY_EXCEPTION_FAIL',
  GET_VISIBILITY_EXCEPTION_CLEAR: 'GET_VISIBILITY_EXCEPTION_CLEAR',

  ADD_NEW_FILE_ACTION: 'ADD_NEW_FILE_ACTION',
  ADD_NEW_TRACKING_STATUS_ACTION: 'ADD_NEW_TRACKING_STATUS_ACTION',

  GET_FOOTER_CONTENT: 'GET_FOOTER_CONTENT',
  GET_FOOTER_CONTENT_SUCCESS: 'GET_FOOTER_CONTENT_SUCCESS',
  GET_FOOTER_CONTENT_FAIL: 'GET_FOOTER_CONTENT_FAIL',

  SET_SELECTED_VISIBILITY: 'SET_SELECTED_VISIBILITY',
  CLEAR_SELECTED_VISIBILITY: 'CLEAR_SELECTED_VISIBILITY',

  GET_VISIBILITY_EXCEL_DATA: 'GET_VISIBILITY_EXCEL_DATA',
  GET_VISIBILITY_EXCEL_DATA_SUCCESS: 'GET_VISIBILITY_EXCEL_DATA_SUCCESS',
  GET_VISIBILITY_EXCEL_DATA_FAIL: 'GET_VISIBILITY_EXCEL_DATA_FAIL',

  SENT_EMAIL_VISIBILITY: 'SENT_EMAIL_VISIBILITY',
  SENT_EMAIL_VISIBILITY_SUCCESS: 'SENT_EMAIL_VISIBILITY_SUCCESS',
  SENT_EMAIL_VISIBILITY_FAIL: 'SENT_EMAIL_VISIBILITY_FAIL',

  GET_VISIBILITY_EXPORT_DETAILS: 'GET_VISIBILITY_EXPORT_DETAILS',
  GET_VISIBILITY_EXPORT_DETAILS_SUCCESS: 'GET_VISIBILITY_EXPORT_DETAILS_SUCCESS',
  GET_VISIBILITY_EXPORT_DETAILS_FAIL: 'GET_VISIBILITY_EXPORT_DETAILS_FAIL',

  EDIT_GENETRAL_BTN_ACTION: 'EDIT_GENETRAL_BTN_ACTION',
  EDIT_DETAILS_BTN_ACTION: 'EDIT_DETAILS_BTN_ACTION',
  UPDATE_REF_AND_DOCK_NO: 'UPDATE_REF_AND_DOCK_NO',
  UPDATE_REF_AND_DOCK_NO_SUCCESS: 'UPDATE_REF_AND_DOCK_NO_SUCCESS',
  UPDATE_REF_AND_DOCK_NO_FAIL: 'UPDATE_REF_AND_DOCK_NO_FAIL',

  UPDATE_SHIPMENT_NOTE: 'UPDATE_SHIPMENT_NOTE',
  UPDATE_SHIPMENT_NOTE_SUCCESS: 'UPDATE_SHIPMENT_NOTE_SUCCESS',
  UPDATE_SHIPMENT_NOTE_FAIL: 'UPDATE_SHIPMENT_NOTE_FAIL',

  UPDATE_SHIPMENT_DETAILS: 'UPDATE_SHIPMENT_DETAILS',
  UPDATE_SHIPMENT_DETAILS_SUCCESS: 'UPDATE_SHIPMENT_DETAILS_SUCCESS',
  UPDATE_SHIPMENT_DETAILS_FAIL: 'UPDATE_SHIPMENT_DETAILS_FAIL',

  SUPPLIER_TYPE_DATA: 'SUPPLIER_TYPE_DATA',
  BRANCH_DATA: 'BRANCH_DATA',
  TRANSPORTATION_PROVIDER_DATA: 'TRANSPORTATION_PROVIDER_DATA',
};

export default VisibilityTypes;
